import { c as _c } from "react/compiler-runtime";
import { getCdnUrl } from '@morpho-org/dapp-core';
import { InfoTooltip } from '@morpho-org/ui-v6/client';
import { cn } from '@morpho-org/ui-v6/utils';
import Image from 'next/image';
import { memo } from 'react';

// A 1-of-1 Safe is commonly an institutional MPC wallet (Fireblocks, Fordefi, etc.) whose single
// signer is indistinguishable from a standard EOA onchain. Clarify that without vouching either way.
const SINGLE_SIGNER_TOOLTIP = 'This Safe requires 1 of 1 signatures. The single signer may be an EOA or an ' + 'institutional MPC wallet. Morpho cannot verify the underlying key setup onchain.';
interface SafeQuorumProps {
  safeQuorum?: string;
  /** text-* class controlling the text variant (default: `text-md`). */
  textClassName?: string;
}
const SafeQuorum = t0 => {
  const $ = _c(11);
  const {
    safeQuorum,
    textClassName: t1
  } = t0;
  const textClassName = t1 === undefined ? "text-md" : t1;
  const isSingleSigner = safeQuorum === "1/1";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src={getCdnUrl("v2/assets/icons/safe.png")} alt="Safe logo" width={18} height={18} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== textClassName) {
    t3 = cn(textClassName, "text-foreground");
    $[1] = textClassName;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== safeQuorum || $[4] !== t3) {
    t4 = <span className={t3}>SAFE {safeQuorum}</span>;
    $[3] = safeQuorum;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isSingleSigner) {
    t5 = isSingleSigner && <InfoTooltip tooltipContent={SINGLE_SIGNER_TOOLTIP} />;
    $[6] = isSingleSigner;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <>{t2}{t4}{t5}</>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default memo(SafeQuorum);